import { Box } from '@mui/material';
import { Fragment, type ReactNode } from 'react';
import { liveTranscriptHighlightSx } from 'src/components/Assistant/live-transcript/live-transcript.styles';

interface RenderHighlightsInput {
  text: string;
  query: string;
  matchOffset: number;
  currentMatchIndex: number;
}

export const renderTextWithHighlights = ({
  text,
  query,
  matchOffset,
  currentMatchIndex,
}: RenderHighlightsInput): ReactNode => {
  if (!query) {
    return text;
  }

  const sourceText = text.toLowerCase();
  const searchPattern = query.toLowerCase();

  if (searchPattern.length === 0) {
    return text;
  }

  const nodes: ReactNode[] = [];
  let cursor = 0;
  let localMatchIndex = 0;

  while (cursor <= sourceText.length) {
    const found = sourceText.indexOf(searchPattern, cursor);

    if (found === -1) {
      if (cursor < text.length) {
        nodes.push(<Fragment key={`t-${cursor}`}>{text.slice(cursor)}</Fragment>);
      }
      break;
    }

    if (found > cursor) {
      nodes.push(<Fragment key={`t-${cursor}`}>{text.slice(cursor, found)}</Fragment>);
    }

    const globalIndex = matchOffset + localMatchIndex;
    nodes.push(
      <Box
        key={`m-${found}`}
        component="mark"
        data-match-index={globalIndex}
        sx={liveTranscriptHighlightSx(globalIndex === currentMatchIndex)}
      >
        {text.slice(found, found + searchPattern.length)}
      </Box>,
    );

    localMatchIndex += 1;
    cursor = found + searchPattern.length;
  }

  return nodes;
};
